<ng-select [items]="TCGADatasets"
            bindLabel="name"
            placeholder="Survival Plot"
            [ngModel]="selectedTCGADataset"
            (ngModelChange)="selectTCGADataset($event)">
</ng-select>

<div *ngIf="selectedTCGADataset && graph" id="survival-plot">
    <plotly-plot
      [data]="graph.data"
      [layout]="graph.layout"
    ></plotly-plot>
  </div>

